import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/app-setting/redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { AppSettingsNav } from '../common/ui/AppSettingsNav';
import { CustomCss } from './custom-css-class/CustomCss';
import { CUSTOM_CSS } from 'drapcode-constant';

export class CustomCssTab extends Component {
  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    fullScreen: false,
    cssFullScreen: false,
  };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions.loadProjectDetailAppSetting({ projectId, version });
    actions.getPermissionFlags({ projectId });
  }

  toggleFullscreen = () => {
    this.setState((prevState) => ({
      fullScreen: !prevState.fullScreen,
    }));
  };
  toggleCssFullscreen = () => {
    this.setState((prevState) => ({
      cssFullScreen: !prevState.cssFullScreen,
    }));
  };

  render() {
    const fullScreenCss = {
      position: 'relative',
      top: '-119px',
      left: '-15px',
      width: '97vw',
    };
    const { cssFullScreen } = this.state;
    const { appSetting, actions, permission, match } = this.props;
    const {
      projectDetail,
      permissionFlags,
      addProjectCustomCssPending,
      addProjectCustomCssClassPending,
      addProjectCustomCssUrlPending,
    } = appSetting;
    if (!projectDetail) {
      return '';
    }
    let permissionsArray = [];
    if (permissionFlags && permissionFlags.length > 0) {
      permissionsArray = permissionFlags || [];
    }
    const { projectId, version } = match.params;
    return (
      <CommonPageComponent>
        <AppSettingsNav activeTab={'customCSS'} projectDetail={projectDetail} />
        <div style={cssFullScreen ? fullScreenCss : {}}>
          <CustomCss
            projectId={projectId}
            version={version}
            projectDetail={projectDetail}
            actions={actions}
            showCustomCSSLoader={addProjectCustomCssPending}
            showCustomCSSClassLoader={addProjectCustomCssClassPending}
            showCustomCSSUrlLoader={addProjectCustomCssUrlPending}
            appSetting={appSetting}
            togglestate={cssFullScreen}
            toggleCssFullscreen={this.toggleCssFullscreen}
            deleteFlag={permissionsArray.includes(CUSTOM_CSS)}
          />
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomCssTab);
